import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { AuthService } from 'src/services/auth.service';

@Component({
  selector: 'app-profile-popover',
  templateUrl: './profile-popover.page.html',
  styleUrls: ['./profile-popover.page.scss'],
})
export class ProfilePopoverPage {
  name: string;
  email: string;
  isBusiness = false;

  constructor(
    public popoverCtrl: PopoverController,
    public authService: AuthService,
  ) {
    const user = this.authService.user;
    this.name = user.displayName;
    this.email = user.email;

    this.isBusiness = true;
    user.providerData.map((val) => {
      if (val.providerId === 'phone') {
        this.isBusiness = false;
        return;
      }
    });
  }

  async sendFeedback() {
    (window as any).$unthread.inAppChat('toggle', 'show');
  }

  openHelpdesk() {
    window.open('https://docs.unthread.io/introduction', '_blank');
  }

  logout() {
    this.authService.logout();
    this.popoverCtrl.dismiss();
  }
}
